export const CLEAR_ANALYZE_REPORT = "CLEAR_ANALYZE_REPORT";
export const FETCH_ANALYZE_REPORT = "FETCH_ANALYZE_REPORT";
export const LIST_ANALYZE_REPORT = "LIST_ANALYZE_REPORT";
export const ERROR_ANALYZE_REPORT = "ERROR_ANALYZE_REPORT";